import React, { Component, Suspense } from 'react';
import Page from '../../components/Page';
import { connect } from 'react-redux';

import { toWapi } from '../../util/api';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import InstagramIcon from '@mui/icons-material/Instagram';
import { TextField, Typography, Button, Paper, Stack, CircularProgress } from '@mui/material';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import DoneIcon from '@mui/icons-material/Done';
import { styled } from '@mui/material/styles';

const Swagger = React.lazy(() => import('../../components/Swagger'));
const Item = styled(Paper)(({ theme }) => ({
	backgroundColor: '#fff',
	...theme.typography.body2,
	padding: theme.spacing(1),
	textAlign: 'left',
	color: theme.palette.text.secondary,
}));

class Documentation extends Component {
	state = {
		copiedPid: false,
		copiedToken: false,
		phones: null,
		loading: true,
	};
	onCopyPid = () => {
		if (!this.state.copiedPid) this.setState({ copiedPid: true });
		clearTimeout(this.timeout);
		this.timeout = setTimeout(() => {
			this.setState({ copiedPid: false });
		}, 2000);
	};
	onCopyToken = () => {
		if (!this.state.copiedToken) this.setState({ copiedToken: true });
		clearTimeout(this.timeout);
		this.timeout = setTimeout(() => {
			this.setState({ copiedToken: false });
		}, 2000);
	};

	get token() {
		let product = this.props.product;
		return product && product.settings && product.settings.wapi_token;
	}

	get pid() {
		let product = this.props.product;
		return product && product.id;
	}

	toWapi = (path, data) => {
		return toWapi(`/api/${this.pid}${path}`, this.token, data);
	};

	componentDidMount() {
		this.toWapi('/listPhones')
			.then((req) => {
				let list = req && req.data;
				this.setState({ phones: list, loading: false });
			})
			.catch((e) => {
				this.setState({ loading: false });
			});
	}

	render() {
		let product = this.props.product;
		return (
			<Page title="Developers" subtitle="Instagram Documentation" icon={<InstagramIcon />}>
				<Stack spacing={2}>
					<Item>
						<div>
							{product && product.id ? (
								<div style={{ margin: 'auto', paddingBottom: '10px' }}>
									<Typography style={{ fontSize: '16px', fontWeight: 'bold', textAlign: 'center' }}>Product ID</Typography>
									<TextField
										label="Product ID"
										fullWidth
										value={product.id}
										onChange={({ target: { value } }) => this.setState({ value, copiedToken: false })}
										action
										fluid
										InputProps={{
											endAdornment: (
												<CopyToClipboard text={product.id} onCopy={this.onCopyPid}>
													<Button
														sx={{ borderRadius: '4px' }}
														color={this.state.copiedPid ? 'success' : undefined}
														size="medium"
														margin="normal"
														variant="contained"
														endIcon={this.state.copiedPid ? <DoneIcon /> : <ContentCopyIcon />}
													>
														{this.state.copiedPid ? 'Copied' : 'Copy'}
													</Button>
												</CopyToClipboard>
											),
										}}
									>
										{/* <input readOnly />

									<CopyToClipboard text={product.id} onCopy={this.onCopyPid}>
										<Button icon color={this.state.copiedPid ? '#1A2027' : undefined}>
											<Icon name={this.state.copiedPid ? 'check' : 'copy'} />
											Copy
										</Button>
									</CopyToClipboard> */}
									</TextField>
								</div>
							) : (
								''
							)}

							{product.settings && product.settings.wapi_token ? (
								<div style={{ margin: 'auto' }}>
									<Typography style={{ fontSize: '16px', fontWeight: 'bold', textAlign: 'center' }}>Token</Typography>
									<TextField
										label="Token"
										fullWidth
										margin="normal"
										value={product.settings.wapi_token}
										onChange={({ target: { value } }) => this.setState({ value, copiedToken: false })}
										action
										fluid
										InputProps={{
											endAdornment: (
												<CopyToClipboard text={product.settings.wapi_token} onCopy={this.onCopyToken}>
													<Button
														sx={{ borderRadius: '4px' }}
														// color={this.state.copiedToken ? '#1A2027' : undefined}
														color={this.state.copiedToken ? 'success' : undefined}
														size="medium"
														variant="contained"
														endIcon={this.state.copiedToken ? <DoneIcon /> : <ContentCopyIcon />}
													>
														{this.state.copiedToken ? 'Copied' : 'Copy'}
													</Button>
												</CopyToClipboard>
											),
										}}
									>
										{/* <input readOnly />

									<CopyToClipboard text={product.settings.wapi_token} onCopy={this.onCopyToken}>
										<Button icon color={this.state.copiedToken ? '#1A2027' : undefined}>
											<Icon name={this.state.copiedToken ? 'check' : 'copy'} />
											Copy
										</Button>
									</CopyToClipboard> */}
									</TextField>
								</div>
							) : (
								''
							)}
						</div>
						{this.state.loading ? (
							<Stack sx={{ marginTop: '20%', marginLeft: '50%' }} attached="bottom">
								<CircularProgress disableShrink />
							</Stack>
						) : (
							<Suspense fallback={<CircularProgress disableShrink />}>
								<Swagger product={product} phones={this.state.phones} doc="whatsapp" />
							</Suspense>
						)}
					</Item>
				</Stack>
			</Page>
		);
	}
}

export default connect((state) => ({ user: state.access.user.loggedUserObj, product: state.product.maytapi }))(Documentation);
